module.exports = __webpack_public_path__ + "img/icon-pen-circle.5ae8c65.svg";